import React, { useState, useEffect } from 'react';
import LeaseApiService from '../../services/apiService';
import { FaSave, FaChevronLeft } from 'react-icons/fa';
import { ClipLoader } from 'react-spinners';
import { toast } from 'react-toastify';
import { useSelector } from 'react-redux';
import { getCompany, getName } from '../../../Redux/selecters';
import MasterDetails from './masterDetails';
import UnitDetails from './unitDetails';
import ImagesList from './images';
import SalesDetails from './salesDetails';
import BuyerSummery from './buyerSummery';
import moment from 'moment/moment';
import LeaseDetails from './leaseDetails';
import UnitFeature from './unitFeatures';
import Advertisement from './advertisement';
import Payable from './payable';
import axios from 'axios';
import { useTranslation } from 'react-i18next';
import { endPoint } from '../../EndPoints/endPoint';

const createEmptyRow = () => ({
  id: Date.now() + Math.random(),
  file: null,
  fileName: '',
  remarks: '',
  filePath: '',
  isNew: true,
  fullUrl: '',
});
const UpdateUnitMaster = ({ rowData, onClose, viewOnly = false }) => {
  const { t } = useTranslation();
  const apiService = new LeaseApiService();
  const userName = useSelector(getName);
  const [activeFY, setActiveFY] = useState(null);
  const [activeTab, setActiveTab] = useState(0);
  const [loading, setloader] = useState(false);
  const [deletedFiles, setDeletedFiles] = useState();
  
  // Master Listings
  const [measurementList, setMeasurementList] = useState([]);
  const [salersList, setSalesPersonList] = useState([]);
  const [bedRoomList, setBedRoomList] = useState([]);
  const [landlordList, setLandlordList] = useState([]);
  const [propertyList, setPropertyList] = useState([]);
  const [communityList, setcommunityList] = useState([]);
  const [unitTypeList, setUnitTypeList] = useState([]);
  const [unitViewList, setunitViewList] = useState([]);
  const [imageView, setImageView] = useState([]);
  const [unitCategoryList, setunitCategoryList] = useState([]);
  const [floorList, setFloorList] = useState([]);
  const [tableLoading, setTableLoading] = useState(false);
  const [countriesList, setCountries] = useState([]);
  const [cityList, setCityList] = useState([]);
  // Unit Listings
  const [manDateList, setManDateList] = useState([]);
  const [reserveAccList, setReserveAccList] = useState([]);
  const [keyStatusList, setKeyStatusList] = useState([]);
  const [unitCostList, setUnitCostList] = useState([]);
  const [paymentPlan, setPaymentPlan] = useState([]);
  const [projectStatus, setProjectStatus] = useState([]);
  const [costAccount, setCostAccount] = useState([]);
  const [agent, setAgent] = useState([]);
  const [furnishing, setFurnishing] = useState([]);
  const [refferedBy, setRefferedBy] = useState([]);
  const [enteredBy, setEnteredBy] = useState([]);
  const [furniturePlan, setFurniturePlan] = useState([]);
  const [period, setPeriod] = useState([]);
  const [sizeType, setSizeType] = useState([]);
  const [bankList, setBankList] = useState([]);
  const [currencyList, setCurrency] = useState([]);
  const [featuresList, setFeaturesList] = useState([]);
  const [attachments, setAttachments] = useState([createEmptyRow()]);
  const leaseData = rowData;
  const [unitAudit, setUnitAudit] = useState({ createdBy: '0', createdOn: null });
  const [recordStatus, setRecordStatus] = useState('');
  const today = new Date();
  const formattedDate = today.toISOString().split('T')[0]; // DD-MMM-YYYY
  const formatDate = (date) => {
    return moment(date).format('DD-MMM-YYYY');
  };

  const [transectionData, setTransectionData] = useState({
    saller: null,
    landlordId: null,
    property: null,
    community: null,
    unitType: null,
    unitCategory: null,
    country: null,
    city: null,
    unitView: null,
    floor: null,
    bedRooms: null,
    unitNo: '',
    contactPerson: '',
    municipltyNo: '',
    refNo: '',
    unitClass: 'Sale',
    sector: '',
    block: '',
    bathRoom: '',
    balcony: '',
    livingarea: '',
    terraceArea: '',
    totalArea: '',
    netArea: '',
    parking: '',
    unitRate: '',
    remarks: '',
    parkingPrice: '',
    resale: false,
  });
  const [unitDetails, setUnitDetails] = useState({
    mandate: null,
    reservedAccCode: null,
    statusKey: null,
    unitCost: null,
    paymentPlan: null,
    status: null,
    costAccount: null,
    agent: null,
    furnishing: null,
    refferedBy: null,
    enteredBy: '0',
    furniturePlan: null,
    unitModel: '',
    serviceCharge: '',
    unitStyle: '',
    reservedFund: '',
    storeRoom: '',
    plotNO: '',
    company: '',
    financeOffered: '',
    rentAmount: '',
    plotSize: '',
    additionalWorkCost: '',
    streetNo: '',
    opt2Cost: '',
    opt3Cost: '',
    furnitureCost: '',
    occupied: false,
    propertyRegistered: false,
    mortgaged: false,
    leased: false,
    completionDate: '',
    expiryDate: formattedDate,
    reffferedDate: formattedDate,
    enteredDate: formattedDate,
    modifiedDate: formattedDate,
  });
  const [salesDetails, setSalesDetails] = useState({
    currency: null,
    orignalPrice: '',
    orignalRateSqft: '',
    profit: '',
    profitCalculate: '',
    listingPrice: '',
    listingPriceRate: '',
    priceinothercontry: '',
    mainSalePrice: '',
    marketAnalysis: '',
    to: '',
    commPaid: '',
    commPaidCalculate: '',
    commSeller: '',
    commSellerCalculate: '',
    sellerTransferFee: '',
    sellerTransferFeeCalcu: '',
    buyerTransferFee: '',
    buyerTransferFeeCalcu: '',
    legalFee: '',
    legalFeeCalcu: '',
    miscFee: '',
    miscFeeCalcu: '',
    comment: '',
    sellerPaidDev: '',
    sellerPaidDevCalcu: '',
  });
  const [buyerSummery, setBuyerSummery] = useState({
    sellerTransfer: '',
    developerBalance: '',
    developerBalancePerc: '',
    BuyerCommission: '',
    BuyerCommissionPerc: '',
    DlDTransfer: '',
    DlDTransferPerc: '',
    administrationFee: '',
    administrationFeePerc: '',
    otherFee: '',
    otherFeePerc: '',
    allPrice: '',
    allPricePerc: '',
  });
  const [leaseDetails, setLeaseDetails] = useState({
    dueDate: formattedDate,
    rentPerAnum: '',
    rentByMonth: '',
    rentPerDay: '',
    securityDeposit: '',
    securityDepositPerc: '',
    tenantCommission: '',
    tenantCommissionPerc: '',
    landlordCommission: '',
    landlordCommissionPerc: '',
    maintenanceFee: '',
    rentPayable: '',
    IbanNo: '',
    secDepositPayable: '',
    commissionPayable: '',
    bankName: null,
    accountNo: '',
    fixedCharges: '',
    variableCharges: '',
    installment: '',
  });
  const [advertisement, setAdvertisement] = useState({
    publishStatus: false,
    xmlFeed: false,
    openHouse: false,
    marketingDesc: '',
    remarks1: '',
    remarks2: '',
    remarks3: '',
  });

  useEffect(() => {
    const financialYears = JSON.parse(localStorage.getItem('financialYear')) || [];
    const activeFinancialYear = financialYears?.find((fy) => fy.isActive);
    if (activeFinancialYear) {
      setActiveFY({ label: activeFinancialYear.name, value: activeFinancialYear });
    }
    if (!leaseData?.ref_No) {
      toast.warning(t('unitMaster.validationMessages.noUnitSelected'));
      if (onClose) onClose();
      return;
    }
    fetchDropdownData();
  }, [leaseData?.ref_No, onClose]);
  const fetchDropdownData = async () => {
    if (!leaseData?.ref_No) return;
    try {
      setTableLoading(true);
      // UNIT_RA_MULTIDROP (Lease Finance) confirmed live to return these
      // types correctly (lowercased "UM" prefix only, e.g. "umBedrooms").
      // Property/ReferredBy/EnteredBy/CostAccounts/AreaMeasurements/
      // SalesPersons/SellerNames/ReservedFundAccounts/Accounts/Furnished are
      // NOT returned by it at all (confirmed empty) - those are fetched
      // separately below from GET_UNIT_MULTIDROP (main backend) instead.
      // Switching everything to GET_UNIT_MULTIDROP (as a reference "-RA-"
      // copy of this project does) regressed UMSellers/Landlord, which that
      // backend doesn't return the same way - so this keeps both sources.
      const params = new URLSearchParams();
      params.append(
        'dropdownTypes',
        'UMBedrooms,UMFloors,UMUnitViews,UMUnitTypes,UMUnitCategories,UMImageTypes,UMKeyStatus,UMMandate,UMSizeTypes,UMPeriods',
      );
      const res = await apiService.getApiParamater('UNIT_RA_MULTIDROP', `?${params.toString()}`);
      const scndparams = new URLSearchParams();
      scndparams.append(
        'dropdownTypes',
        'UMBanks,UMPaymentPlans,UMCountries,UMCommunities,UMSellers,UMFurniturePlans,UMAgents,UMProjectStatus,UMFurnishing,UMCurrencies',
      );
      const scndRes = await apiService.getApiParamater('UNIT_RA_MULTIDROP', `?${scndparams.toString()}`);
      const missingParams = new URLSearchParams();
      missingParams.append(
        'dropdownTypes',
        'UMReferredBy,UMProperties,UMEnteredBy,UMCostAccounts,UMAreaMeasurements,UMSalesPersons,UMSellerNames,UMReservedFundAccounts,UMAccounts,UMFurnished',
      );
      const missingRes = await apiService.getApiParamater('GET_UNIT_MULTIDROP', `?${missingParams.toString()}`);
      const d1 = res?.data?.dropdowns || {};
      const d2 = scndRes?.data?.dropdowns || {};
      const d3 = missingRes?.data?.dropdowns || {};
      setBedRoomList(d1.umBedrooms);
      setCostAccount(d3.UMCostAccounts);
      setEnteredBy(d3.UMEnteredBy);
      setFloorList(d1.umFloors);
      setImageView(d1.umImageTypes);
      setKeyStatusList(d1.umKeyStatus);
      setManDateList(d1.umMandate);
      setPeriod(d1.umPeriods);
      setPropertyList(d3.UMProperties);
      setRefferedBy(d3.UMReferredBy);
      setSizeType(d1.umSizeTypes);
      setunitCategoryList(d1.umUnitCategories);
      setunitViewList(d1.umUnitViews);
      setUnitTypeList(d1.umUnitTypes);
      setAgent(d2.umAgents);
      setProjectStatus(d2.umProjectStatus);
      setcommunityList(d2.umCommunities);
      setMeasurementList(d3.UMAreaMeasurements);
      setUnitCostList(d3.UMEnteredBy);
      setLandlordList(d2.umSellers);
      setSalesPersonList(d3.UMSalesPersons);
      setBankList(d2.umBanks);
      setPaymentPlan(d2.umPaymentPlans);
      setCountries(d2.umCountries);
      setFurnishing(d2.umFurnishing);
      setCurrency(d2.umCurrencies);
      setFurniturePlan(d2.umFurniturePlans);
      setReserveAccList(d3.UMReservedFundAccounts);

      const detailParams = new URLSearchParams();
      detailParams.append('Action', 'GetUnitDetailsByRefNo');
      detailParams.append('UnitRefNo', leaseData.ref_No);
      const unitRes = await apiService.getApiParamater('UNIT_RA_COMMON', `?${detailParams.toString()}`);
      const rawResult = unitRes?.data?.result;
      const ud =
        rawResult?.data !== undefined && typeof rawResult?.data === 'object' && !Array.isArray(rawResult.data)
          ? rawResult.data
          : typeof rawResult === 'object' && rawResult !== null
            ? rawResult
            : {};

      const pickNonZero = (...vals) => {
        for (const v of vals) {
          const s = v !== undefined && v !== null ? String(v).trim() : '';
          if (s !== '' && s !== '0') return v;
        }
        return '';
      };
      const propNo = pickNonZero(leaseData?.property_No, ud.property_No);
      if (propNo) {
        const fp = new URLSearchParams();
        fp.append('Action', 'GetUnitFeatureByRefNo');
        fp.append('UnitRefNo', leaseData.ref_No);
        const fRes = await apiService.getApiParamater('UNIT_RA_COMMON', `?${fp.toString()}`);
        setFeaturesList(fRes?.data?.result?.data || []);
      } else {
        setFeaturesList([]);
      }
      // Get Unit Images
      const imagesParam = new URLSearchParams();
      imagesParam.append('Action', 'GetUnitImagesByRefNo');
      imagesParam.append('UnitRefNo', leaseData.ref_No);
      const imgResp = await apiService.getApiParamater('UNIT_RA_COMMON', `?${imagesParam.toString()}`);
      const imgResult = imgResp?.data?.result?.data;
      if (imgResult?.length || imgResult?.record_Id) {
        if (imgResult?.length > 0) {
          const apiFiles = imgResult.map((item) => ({
            id: Date.now() + Math.random(),
            file: null,
            // record_Id is required to actually delete this row later -
            // spUnitImage_Delete needs it, and it was never captured before.
            record_Id: item.record_Id,
            fileName: item.image_Filename,
            remarks: item.image_Description && item.image_Description !== '0' ? item.image_Description : '',
            filePath: item?.folder,
            isNew: false,
            fullUrl: item.url,
          }));
          setAttachments([...apiFiles, createEmptyRow()]);
        } else {
          const apiFiles = [{
            id: Date.now() + Math.random(),
            file: null,
            record_Id: imgResult.record_Id,
            fileName: imgResult.image_Filename,
            remarks: imgResult.image_Description && imgResult.image_Description !== '0' ? imgResult.image_Description : '',
            filePath: imgResult?.folder,
            isNew: false,
            fullUrl: imgResult.url,
          }];
          setAttachments([...apiFiles, createEmptyRow()]);
        }
      }
      const findOpt = (arr, text) => {
        const t = text !== undefined && text !== null ? String(text).trim() : '';
        if (!t || !arr?.length) return null;
        const row = arr.find((x) => String(x?.text ?? '').trim() === t || String(x?.value ?? '').trim() === t);
        return row ? { value: row, label: row.text } : { label: t, value: { text: t, value: t } };
      };
      const pick = (...vals) => {
        for (const v of vals) {
          if (v !== undefined && v !== null && String(v).trim() !== '') return v;
        }
        return '';
      };
      const parseApiDate = (val) => {
        if (!val) return '';
        const d = new Date(val);
        return Number.isNaN(d.getTime()) ? '' : d;
      };
      const valueOrEmpty = (...vals) => {
        const value = pick(...vals);

        return value === 0 ||
          value === "0" ||
          value === null ||
          value === undefined
          ? ""
          : String(value);
      };
      let cityOpts = [];
      const countryLabel = String(pick(ud.country) || '').trim();
      if (countryLabel && d2.umCountries?.length) {
        const countryRow = d2.umCountries.find((c) => c.text === countryLabel);
        if (countryRow) {
          const cityParams = new URLSearchParams();
          cityParams.append('DropdownFor', 'UMCitiesByCountry');
          cityParams.append('CascadValue', countryRow.text);
          const cityRes = await apiService.getApiParamater('UNIT_RA_CASCAD', `?${cityParams.toString()}`);
          cityOpts = cityRes?.data?.items || [];
        }
      }
      setCityList(cityOpts);

      const propName = pickNonZero(leaseData?.property_Name, ud.property_Name);
      const propRow = d3.UMProperties?.find(
        (p) => (propNo && String(p.value) === String(propNo)) || (propName && String(p.text) === String(propName)),
      );
      const property = propRow
        ? { value: propRow, label: propRow.text }
        : propNo || propName
          ? { value: { value: propNo || '0', text: propName || String(propNo) }, label: propName || String(propNo) }
          : null;

      let communityName = '';
      if (propNo) {
        const communityParams = new URLSearchParams();
        communityParams.append('Action', 'GetCommunityByPropertyNo');
        communityParams.append('PropertyNo', propNo);
        const communityRes = await apiService.getApiParamater('UNIT_RA_COMMON', `?${communityParams.toString()}`);
        communityName = communityRes?.data?.result?.data?.community_Name || '';
      }

      setUnitAudit({
        createdBy: String(pick(ud.created_By, '0')),
        createdOn: parseApiDate(ud.created_On) || today,
      });
      // Matches legacy GetRecord(): DBNull or the literal string "0" both mean "no status".
      setRecordStatus(String(ud.status) === '0' ? '' : String(pick(ud.status, '')));

      setTransectionData((prev) => ({
        ...prev,
        refNo: String(pick(leaseData.ref_No, ud.ref_No)),
        unitNo: String(pick(leaseData.unit_No, ud.unit_No)),
        unitClass: String(pick(leaseData.unit_Class, ud.unit_Class, 'Sale')),
        property,
        country: findOpt(d2.umCountries, pick(ud.country)),
        city: findOpt(cityOpts, pick(ud.city)),
        community: communityName ? { label: communityName, value: communityName } : findOpt(d2.umCommunities, pick(ud.community, ud.community_Name)),
        unitType: findOpt(d1.umUnitTypes, pick(leaseData.unit_Type, ud.unit_Type)),
        unitCategory: findOpt(d1.umUnitCategories, pick(leaseData.unit_Category, ud.unit_Category)),
        unitView: findOpt(d1.umUnitViews, pick(leaseData.unit_View, ud.unit_View)),
        floor: findOpt(d1.umFloors, pick(leaseData.floor, ud.floor)),
        bedRooms: findOpt(d1.umBedrooms, pick(leaseData.bedrooms, ud.bedrooms)),
        totalArea: valueOrEmpty(pick(leaseData.total_Area, ud.total_Area, prev.totalArea)),
        netArea: valueOrEmpty(pick(leaseData.measured_Area, ud.measured_Area, prev.netArea)),
        unitRate: valueOrEmpty(pick(leaseData.sqft_Rate, ud.sqft_Rate, prev.unitRate)),
        // This textarea saves to InternalRemarks (see handleSave: internalRemarks:
        // transectionData?.remarks) - ud.remarks is a different DB column that
        // holds the Advertisement tab's Marketing Description, so reading it
        // here was showing/losing the wrong value.
        remarks: valueOrEmpty(pick(ud.internalRemarks, leaseData.remarks, prev.remarks)),
        block: valueOrEmpty(pick(ud.block, prev.block)),
        bathRoom: valueOrEmpty(pick(ud.bathrooms, prev.bathRoom)),
        balcony: valueOrEmpty(pick(ud.balcony, prev.balcony)),
        terraceArea: valueOrEmpty(pick(ud.terrace, prev.terraceArea)),
        livingarea: valueOrEmpty(pick(ud.livingRooms, prev.livingarea)),
        parking: valueOrEmpty(pick(leaseData.parking, ud.parking, prev.parking)),
        parkingPrice: valueOrEmpty(pick(leaseData.parking_Price, ud.parking_Price, prev.parkingPrice)),
        sector: valueOrEmpty(pick(ud.unit_Zone, prev.sector)),
        municipltyNo: valueOrEmpty(pick(ud.rerA_STR_No, prev.municipltyNo)),
        saller: findOpt(d2.umSellers, pick(ud.seller_Name)),
        landlordId: (() => {
          const opt = findOpt(d2.umSellers, pick(ud.seller_Id));
          return opt ? { value: opt.value, label: opt.value?.value ?? opt.label } : null;
        })(),
        contactPerson: valueOrEmpty(pick(ud.broker_Name, prev.contactPerson)),
      }));

      setUnitDetails((prev) => ({
        ...prev,
        unitModel: String(pick(ud.unit_Model, prev.unitModel)),
        unitStyle: String(pick(ud.unit_Style, prev.unitStyle)),
        streetNo: String(pick(ud.street_No, prev.streetNo)),
        storeRoom: String(pick(ud.storeRooms, leaseData.storeRooms, prev.storeRoom)),
        plotNO: String(pick(ud.plot_No, leaseData.plot_No, prev.plotNO)),
        plotSize: String(pick(ud.plot_Size, leaseData.plot_Size, prev.plotSize)),
        serviceCharge: String(pick(ud.serviceCharge, prev.serviceCharge)),
        mandate: findOpt(d1.umMandate, pick(ud.mandate, prev.mandate?.label)),
        status: findOpt(d2.umProjectStatus, pick(ud.propertyType, ud.status, leaseData.status, prev.status?.label)),
        unitCost: findOpt(d3.UMEnteredBy, pick(ud.purchase_Value, prev.unitCost?.label)),
        paymentPlan: findOpt(d2.umPaymentPlans, pick(ud.payment_Plan, prev.paymentPlan?.label)),
        agent: findOpt(d2.umAgents, pick(ud.broker_Name, prev.agent?.label)),
        statusKey: findOpt(d1.umKeyStatus, pick(ud.key_Status, prev.statusKey?.label)),
        costAccount: findOpt(d3.UMCostAccounts, pick(ud.exp9, prev.costAccount?.label)),
        furnishing: findOpt(d2.umFurnishing, pick(ud.facilities, prev.furnishing?.label)),
        refferedBy: findOpt(d3.UMReferredBy, pick(ud.refered_By, prev.refferedBy?.label)),
        enteredBy: findOpt(d3.UMEnteredBy, pick(ud.created_By, prev.enteredBy?.label)),
        furniturePlan: findOpt(d2.umFurniturePlans, pick(ud.portfolioManager, prev.furniturePlan?.label)),
        furnitureCost: valueOrEmpty(pick(ud.portfolio, prev.furnitureCost)),
        reservedFund: String(pick(ud.advance_Deposit, prev.reservedFund)),
        reservedAccCode: findOpt(d3.UMReservedFundAccounts, pick(ud.exp10, prev.reservedAccCode?.label)),
        company: String(pick(ud.mortgageCompany, prev.company)),
        financeOffered: String(pick(ud.financeCompany, prev.financeOffered)),
        rentAmount: valueOrEmpty(pick(ud.leaseAmount, prev.rentAmount)),
        completionDate: parseApiDate(ud.completion_Date) || prev.completionDate,
        expiryDate: parseApiDate(ud.leaseExpiry) || prev.expiryDate,
        reffferedDate: parseApiDate(ud.refered_On) || prev.reffferedDate,
        enteredDate: parseApiDate(ud.created_On) || prev.enteredDate,
        leased: Boolean(ud.leased ?? leaseData.leased ?? prev.leased),
        occupied: Boolean(ud.ownerOccupied ?? prev.occupied),
        propertyRegistered: Boolean(ud.propertyRegistered ?? prev.propertyRegistered),
        mortgaged: Boolean(ud.mortgaged ?? prev.mortgaged),
      }));

      setSalesDetails((prev) => ({
        ...prev,
        orignalPrice: valueOrEmpty(pick(ud.total_Value, prev.orignalPrice)),
        listingPrice: valueOrEmpty(pick(ud.roundOff_Value, prev.listingPrice)),
        priceinothercontry: valueOrEmpty(pick(ud.listingPriceUSD, prev.priceinothercontry)),
        currency: findOpt(d2.umCurrencies, pick(ud.currency, prev.currency?.label)),
        profit: valueOrEmpty(pick(ud.premium, prev.profit)),
        profitCalculate: valueOrEmpty(pick(ud.premium_Percent, prev.profitCalculate)),
        mainSalePrice: valueOrEmpty(pick(ud.measured_Value, prev.mainSalePrice)),
        // CMA_Range1/2 -> cmA_Range1/2 (System.Text.Json's camelCase policy
        // lowercases the whole leading acronym run except its last letter,
        // not just the very first character, for names like this).
        marketAnalysis: valueOrEmpty(pick(ud.cmA_Range1, prev.marketAnalysis)),
        to: valueOrEmpty(pick(ud.cmA_Range2, prev.to)),
        legalFee: valueOrEmpty(pick(ud.admin_Fees, prev.legalFee)),
        legalFeeCalcu: valueOrEmpty(pick(ud.admin_Fees_Percent, prev.legalFeeCalcu)),
        miscFee: valueOrEmpty(pick(ud.other_Fees, prev.miscFee)),
        miscFeeCalcu: valueOrEmpty(pick(ud.other_Fees_Percent, prev.miscFeeCalcu)),
        comment: valueOrEmpty(pick(ud.other_Fees_Remarks, prev.comment)),
        commSeller: valueOrEmpty(pick(ud.seller_Commission, prev.commSeller)),
        commSellerCalculate: valueOrEmpty(pick(ud.seller_Commission_Percent, prev.commSellerCalculate)),
        commPaid: valueOrEmpty(pick(ud.buyer_Commission, prev.commPaid)),
        commPaidCalculate: valueOrEmpty(pick(ud.buyer_Commission_Percent, prev.commPaidCalculate)),
        sellerTransferFee: valueOrEmpty(pick(ud.seller_TransferFee, prev.sellerTransferFee)),
        sellerTransferFeeCalcu: valueOrEmpty(pick(ud.seller_TransferFee_Percent, prev.sellerTransferFeeCalcu)),
        buyerTransferFee: valueOrEmpty(pick(ud.buyer_TransferFee, prev.buyerTransferFee)),
        buyerTransferFeeCalcu: valueOrEmpty(pick(ud.buyer_TransferFee_Percent, prev.buyerTransferFeeCalcu)),
        sellerPaidDev: valueOrEmpty(pick(ud.seller_Paid, prev.sellerPaidDev)),
        sellerPaidDevCalcu: valueOrEmpty(pick(ud.seller_Paid_Percent, prev.sellerPaidDevCalcu)),
      }));

      // The % fields are never persisted separately by the legacy app — they're recomputed
      // from the loaded amounts and Rent Per Annum, not read from the database.
      setLeaseDetails((prev) => {
        const rentPerAnumVal = parseFloat(pick(leaseData.rent_Per_Annum, ud.rent_Per_Annum, prev.rentPerAnum)) || 0;
        const pctOfRentPerAnum = (amt) => {
          const a = parseFloat(amt) || 0;
          return rentPerAnumVal ? ((a / rentPerAnumVal) * 100).toFixed(4) : '';
        };
        const securityDepositVal = pick(ud.security_Deposit, prev.securityDeposit);
        const tenantCommissionVal = pick(ud.tenant_Commission, prev.tenantCommission);
        const landlordCommissionVal = pick(ud.landlord_Commission, prev.landlordCommission);
        return {
          ...prev,
          rentPerAnum: valueOrEmpty(pick(leaseData.rent_Per_Annum, ud.rent_Per_Annum, prev.rentPerAnum)),
          rentByMonth: valueOrEmpty(pick(ud.short_Term_Rent, prev.rentByMonth)),
          rentPerDay: valueOrEmpty(pick(ud.rent_Per_Day, prev.rentPerDay)),
          securityDeposit: valueOrEmpty(securityDepositVal),
          securityDepositPerc: pctOfRentPerAnum(securityDepositVal) || prev.securityDepositPerc,
          tenantCommission: valueOrEmpty(tenantCommissionVal),
          tenantCommissionPerc: pctOfRentPerAnum(tenantCommissionVal) || prev.tenantCommissionPerc,
          landlordCommission: valueOrEmpty(landlordCommissionVal),
          landlordCommissionPerc: pctOfRentPerAnum(landlordCommissionVal) || prev.landlordCommissionPerc,
          maintenanceFee: valueOrEmpty(pick(ud.maintenance_Fee, prev.maintenanceFee)),
          dueDate: parseApiDate(ud.effeciency) || prev.dueDate,
          installment: valueOrEmpty(pick(ud.installments, prev.installment)),
          bankName: findOpt(d2.umBanks, pick(ud.rentBankName, prev.bankName?.label)),
          accountNo: valueOrEmpty(pick(ud.rentBankAcNo, prev.accountNo)),
          rentPayable: valueOrEmpty(pick(ud.rentPayableTo, prev.rentPayable)),
          IbanNo: valueOrEmpty(pick(ud.street_Name, prev.IbanNo)),
          secDepositPayable: valueOrEmpty(pick(ud.secDepPayableTo, prev.secDepositPayable)),
          commissionPayable: valueOrEmpty(pick(ud.comPayableTo, prev.commissionPayable)),
          fixedCharges: valueOrEmpty(pick(ud.monthlyIncome, prev.fixedCharges)),
          variableCharges: valueOrEmpty(pick(ud.annualIncome, prev.variableCharges)),
        };
      });

      setAdvertisement((prev) => ({
        ...prev,
        // publishStatus is stored as the literal string "True"/"False", not a real bit —
        // a plain Boolean(...) would incorrectly treat the string "False" as truthy.
        publishStatus: pick(ud.publishStatus, prev.publishStatus) === 'True' || pick(ud.publishStatus, prev.publishStatus) === true,
        xmlFeed: Boolean(ud.adv_Listing ?? prev.xmlFeed),
        openHouse: Boolean(ud.adv_OpenHouse ?? prev.openHouse),
        marketingDesc: valueOrEmpty(pick(ud.remarks, prev.marketingDesc)),
        remarks1: valueOrEmpty(pick(ud.adv_Remarks1, prev.remarks1)),
        remarks2: valueOrEmpty(pick(ud.adv_Remarks2, prev.remarks2)),
        remarks3: valueOrEmpty(pick(ud.adv_Remarks3, prev.remarks3)),
      }));

      // const fileparams = new URLSearchParams();
      // fileparams.append('refNo', String(leaseData.ref_No));
      // fileparams.append('fileCategory', 'Images');
      // const imgRes = await apiService.getApiParamater('GET_FILE', `?${fileparams.toString()}`);
      // if (imgRes?.data?.result?.length) {
      //   const apiFiles = imgRes.data.result.map((item) => ({
      //     id: Date.now() + Math.random(),
      //     file: null,
      //     fileName: item.fileName,
      //     remarks: '',
      //     filePath: item?.filePath,
      //     isNew: false,
      //     fullUrl: item.fullUrl,
      //   }));
      //   setAttachments([...apiFiles, createEmptyRow()]);
      // }
    } catch (error) {
      console.error('Error fetching dropdown data:', error);
      toast.error('Could not load unit for editing');
    } finally {
      setTableLoading(false);
    }
  };
  const handleTabClick = (tabIndex) => {
    setActiveTab(tabIndex);
  };
  // Mirrors the legacy rbSale/rbLease/rbPropertyManagement_CheckedChanged tab-set logic.
  // Yearly Rent is always omitted for now — its visibility depends on a system setting
  // (checkMultiYrLease / tbLease_Setting) with no API exposed to the frontend yet.
  const getTabList = () => {
    const list = [
      { key: 'unitMaster', label: t('unitMaster.tabs.unitMaster') },
      { key: 'unitDetails', label: t('unitMaster.tabs.unitDetails') },
      { key: 'unitFeatures', label: t('unitMaster.tabs.unitFeatures') },
    ];
    const unitClass = transectionData?.unitClass || 'Sale';
    if (unitClass === 'Lease') {
      list.push({ key: 'leaseDetails', label: t('unitMaster.tabs.leaseDetails') });
      if (String(transectionData?.unitType?.label || '').toUpperCase() === 'COMMERCIAL') {
        list.push({ key: 'payable', label: t('unitMaster.tabs.payable') });
      }
    } else if (unitClass === 'PM') {
      list.push({ key: 'leaseDetails', label: t('unitMaster.tabs.pmDetails') });
      list.push({ key: 'payable', label: t('unitMaster.tabs.payable') });
    } else {
      list.push({ key: 'salesDetails', label: t('unitMaster.tabs.salesDetails') });
      list.push({ key: 'buyerSummary', label: t('unitMaster.tabs.buyerSummary') });
    }
    list.push({ key: 'advertisement', label: t('unitMaster.tabs.advertisement') });
    list.push({ key: 'images', label: t('unitMaster.tabs.images') });
    return list;
  };
  const tabList = getTabList();
  // The tab set changes shape with Unit Class, so a stale index could point at a
  // different tab (or nothing) after switching — reset to the first tab instead.
  useEffect(() => {
    setActiveTab(0);
  }, [transectionData?.unitClass]);
  const handleBackClick = () => {
    if (onClose) onClose();
  };

  const additionalDataUpload = async (data, refNo) => {
    const unitFeatures = featuresList?.map((item) => ({
      status: item?.DescType || '0',
      description: item?.Description || '0',
      value: item?.Value,
      cnt: parseFloat(item?.Cnt) || 0,
      amount: parseFloat(item?.Amount) || 0,
      isNewInEdit: item?.IsNewInEdit === 0 ? false : true,
    }));
    const image = data?.map((item) => ({
      record_Id: 0,
      image_Description: item?.originalFileName || '0',
      image_Filename: item?.fileName || '0',
      isDefault: true,
      folder: item?.filePath || '0',
      url: item?.fullUrl || '0',
      isAdded: true,
      isUpdated: false,
      isDeleted: false,
    }));
    const body = {
      refNo: refNo || '0',
      unitFeatures,
      unitImages: image,
      unitPayables: [{ description: '0', value: true, landlord: true, tenant: true }],
      unitYearlyRents: [
        {
          year: 0,
          rentPerSqftRest: 0,
          rentPerSqftKitchen: 0,
          rentPerSqftTerrace: 0,
          totalRent: 0,
          scPerSqftRest: 0,
          scPerSqftKitchen: 0,
          scPerSqftTerrace: 0,
          totalServiceCharge: 0,
          chilledWaterPerSqftRest: 0,
          chilledWaterPerSqftKitchen: 0,
          chilledWaterPerSqftTerrace: 0,
          totalChilledWaterCharge: 0,
        },
      ],
      unitFixedCharges: [{ description: '0', amount: 0 }],
    };
    await apiService.post('POST_UNIT_ADDITIONAL', body);
  };

  const handleUpload = async (ref_No) => {
    const formData = new FormData();

    let token = localStorage.getItem('Token');
    let db = localStorage.getItem('DataBase');
    // const validFiles = attachments.filter(
    //     (item) => item.file instanceof File
    // );
    const validFiles = attachments.filter((item) => item.file instanceof File && item.isNew);

    validFiles.forEach(({ file }) => {
      formData.append('files', file);
    });

    formData.append('refNo', ref_No || '');
    formData.append('fileCategory', 'Images');

    // Must upload to UNIT_FILE_RA (Lease Finance), not the main backend's
    // UNIT_FILE - UnitManagementRARepository.InsertUnitImages moves the file
    // from ITS OWN server's F:\TempFiles, so it has to land there directly.
    const response = await axios.post(endPoint.UNIT_FILE_RA, formData, {
      headers: {
        accept: 'text/plain',
        apikey: 'V+kBloEwqqVho1PINmQI0VJQwSBX2l/e',
        Authorization: `Bearer ${token}`,
        db: db,
      },
    });
    if (response?.data) {
      return response?.data?.result || [];
      // additionalDataUpload(response?.data?.result, ref_No);
    }
  };

  // "Amount due to Developer" is always the complement of "Seller has Paid to Developer".
  const amountDueDev = (parseFloat(salesDetails?.orignalPrice) || 0) - (parseFloat(salesDetails?.sellerPaidDev) || 0);
  const amountDueDevPercent = 100 - (parseFloat(salesDetails?.sellerPaidDevCalcu) || 0);
  const handleSave = async () => {
    try {
      setloader(true);
      // Edit flow: do not block save on client validation; API accepts defaults (e.g. "0") for optional fields.

      const completionDateIso = (() => {
        const c = unitDetails?.completionDate;
        if (!c) return today.toISOString();
        if (c instanceof Date && !Number.isNaN(c.getTime())) return c.toISOString();
        const d = new Date(c);
        return Number.isNaN(d.getTime()) ? today.toISOString() : d.toISOString();
      })();
      const unitFeatures = featuresList?.map((item) => {
        return {
          status: item?.DescType || '0',
          description: item?.Description || '0',
          value:
            typeof item?.Value === 'boolean'
              ? item.Value
              : String(item?.Value).toLowerCase() === 'true',
          cnt: parseFloat(item?.Cnt) || 0,
          amount: parseFloat(item?.Amount) || 0,
          isNewInEdit: item?.IsNewInEdit === 0 ? false : true,
        };
      });
      let uploadedFiles = []
      const hasNewFiles = attachments?.some((item) => item.file instanceof File && item.isNew);
      if (hasNewFiles) {
        uploadedFiles = await handleUpload(transectionData?.refNo);
      }
      // Only one image should ever be the default/cover image - marking
      // every single new one isDefault:true likely violates a "one default
      // per unit" constraint on insert, causing every image after the first
      // to silently fail while the overall save still succeeds. If any
      // existing image is already attached, a new one should never claim
      // default; otherwise the first new image becomes it.
      const hasExistingImages = attachments?.some((item) => !item.isNew && item.fileName);
      let defaultAssigned = hasExistingImages;
      const unitImages = attachments
        ?.filter((item) => (item.isNew && item.file instanceof File) || (!item.isNew && item.fileName))
        .map((item) => {
          if (item.isNew) {
            const uploadedFile = uploadedFiles.find(
              (file) => file.originalFileName === item.file?.name
            );
            const isDefault = !defaultAssigned;
            if (isDefault) defaultAssigned = true;
            return {
              record_Id: 0,
              image_Description: item.remarks || '0',
              image_Filename: uploadedFile?.fileName || '0',
              isDefault,
              folder: '0',
              url: uploadedFile?.fullUrl || '0',
              isAdded: true,
              isUpdated: false,
              isDeleted: false,
            };
          }

          return {
            record_Id: item.record_Id || 0,
            image_Description: item.remarks || '0',
            image_Filename: item.fileName || '0',
            isDefault: true,
            folder: item.filePath || '0',
            url: item.fullUrl || '0',
            isAdded: false,
            // Existing images always go through as "updated" so the backend's
            // spUnitImage_Update runs and picks up any remarks edit - there's
            // no cheap way here to tell whether the remarks actually changed,
            // and always updating is harmless since it just rewrites the same
            // row with (possibly) the same values.
            isUpdated: true,
            isDeleted: false,
          };
        }) || [];
      // Deleted rows are removed from `attachments` immediately for the UI,
      // so they can't come from the map above - they have to be added back in
      // here, with isDeleted:true and their real record_Id, or the backend's
      // spUnitImage_Delete (which requires Record_Id > 0) never gets told
      // anything was removed and the old row stays in the database forever.
      const deletedImagePayload = (deletedFiles || [])
        .filter((item) => item?.record_Id)
        .map((item) => ({
          record_Id: item.record_Id,
          image_Description: item.remarks || '0',
          image_Filename: item.fileName || '0',
          isDefault: false,
          folder: item.filePath || '0',
          url: item.fullUrl || '0',
          isAdded: false,
          isUpdated: false,
          isDeleted: true,
        }));
      unitImages.push(...deletedImagePayload);
      // TEMPORARY - to see exactly what's being sent for images, since a
      // successful unit save with the image still missing from
      // GetUnitImagesByRefNo means either it never made it into this array,
      // or it did and something downstream (backend) dropped it. Check this
      // in the browser console right after clicking Save.
      console.log('unitImages being sent to UPDATE_UNIT_RA:', attachments, unitImages);
      const body = {
        unitRAMasterMain: {
          unitMaster: {
            ref_No: transectionData?.refNo || '0',
            property_No: transectionData?.property?.value?.value || '0',
            property_Name: transectionData?.property?.label || '0',
            unit_No: transectionData?.unitNo || '0',
            rerA_STR_No: transectionData?.municipltyNo || '0',
            street_No: unitDetails?.streetNo || '0',
            street_Name: leaseDetails?.IbanNo || '0',
            unit_Type: transectionData?.unitType?.label || '0',
            unit_Category: transectionData?.unitCategory?.label || '0',
            unit_Style: unitDetails?.unitStyle || '0',
            unit_Model: unitDetails?.unitModel || '0',
            unit_Zone: transectionData?.sector || '0',
            plot_No: unitDetails?.plotNO || '0',
            plot_Size: unitDetails?.plotSize || '0',
            block: transectionData?.block || '0',
            floor: transectionData?.floor?.label || '0',
            unit_View: transectionData?.unitView?.label || '0',
            completion_Date: completionDateIso,
            unit_Class: transectionData?.unitClass || '0',
            livingRooms: transectionData?.livingarea || '0',
            bedrooms: transectionData?.bedRooms?.label || '0',
            storeRooms: unitDetails?.storeRoom || '0',
            parking: transectionData?.parking || '0',
            facilities: unitDetails?.furnishing?.label || '0',
            status: recordStatus || '0',
            payment_Plan: unitDetails?.paymentPlan?.label || '0',
            broker_Name: unitDetails?.agent?.label || '0',
            seller_Id: transectionData?.landlordId?.label || '0',
            seller_Name: transectionData?.saller?.label || '0',
            adv_Listing: Boolean(advertisement?.xmlFeed),
            adv_NewsPaper: false,
            adv_Web: false,
            adv_OpenHouse: Boolean(advertisement?.openHouse),
            adv1: false,
            adv2: false,
            adv3: false,
            adv_Remarks1: advertisement?.remarks1 || '0',
            adv_Remarks2: advertisement?.remarks2 || '0',
            adv_Remarks3: advertisement?.remarks3 || '0',
            remarks: advertisement?.marketingDesc || '0',
            internalRemarks: transectionData?.remarks || '0',
            otherSpace1: '0',
            bathrooms: transectionData?.bathRoom || '0',
            balcony: transectionData?.balcony || '0',
            terrace: transectionData?.terraceArea || '0',
            total_Area: parseFloat(transectionData?.totalArea) || 0,
            measured_Area: parseFloat(transectionData?.netArea) || 0,
            sqft_Rate: parseFloat(transectionData?.unitRate || 0),
            purchase_Value: parseFloat(unitDetails?.unitCost?.label) || 0,
            total_Value: parseFloat(salesDetails?.orignalPrice) || 0,
            measured_Value: parseFloat(salesDetails?.mainSalePrice) || 0,
            roundOff_Value: parseFloat(salesDetails?.listingPrice) || 0,
            parking_Price: parseFloat(transectionData?.parkingPrice) || 0,
            all_In_Price:
              (parseFloat(salesDetails?.profit) || 0) +
              (parseFloat(salesDetails?.sellerPaidDev) || 0) +
              amountDueDev +
              (parseFloat(salesDetails?.commPaid) || 0) +
              (parseFloat(salesDetails?.buyerTransferFee) || 0) +
              (parseFloat(salesDetails?.legalFee) || 0) +
              (parseFloat(salesDetails?.miscFee) || 0),
            premium: parseFloat(salesDetails?.profit) || 0,
            premium_Percent: parseFloat(salesDetails?.profitCalculate) || 0,
            seller_Commission: parseFloat(salesDetails?.commSeller) || 0,
            seller_Commission_Percent: parseFloat(salesDetails?.commSellerCalculate) || 0,
            buyer_Commission: parseFloat(salesDetails?.commPaid) || 0,
            buyer_Commission_Percent: parseFloat(salesDetails?.commPaidCalculate) || 0,
            seller_TransferFee: parseFloat(salesDetails?.sellerTransferFee) || 0,
            seller_TransferFee_Percent: parseFloat(salesDetails?.sellerTransferFeeCalcu) || 0,
            buyer_TransferFee: parseFloat(salesDetails?.buyerTransferFee) || 0,
            buyer_TransferFee_Percent: parseFloat(salesDetails?.buyerTransferFeeCalcu) || 0,
            admin_Fees: parseFloat(salesDetails?.legalFee) || 0,
            admin_Fees_Percent: parseFloat(salesDetails?.legalFeeCalcu) || 0,
            other_Fees: parseFloat(salesDetails?.miscFee) || 0,
            other_Fees_Percent: parseFloat(salesDetails?.miscFeeCalcu) || 0,
            other_Fees_Remarks: salesDetails?.comment || '0',
            seller_Paid: parseFloat(salesDetails?.sellerPaidDev) || 0,
            seller_Paid_Percent: parseFloat(salesDetails?.sellerPaidDevCalcu) || 0,
            developer_Due: amountDueDev,
            developer_Due_Percent: amountDueDevPercent,
            rent_Per_Annum: parseFloat(leaseDetails?.rentPerAnum) || 0,
            short_Term_Rent: parseFloat(leaseDetails?.rentByMonth) || 0,
            short_Term_Period: '0',
            rent_Per_Day: parseFloat(leaseDetails?.rentPerDay) || 0,
            security_Deposit: parseFloat(leaseDetails?.securityDeposit) || 0,
            advance_Deposit: parseFloat(unitDetails?.reservedFund) || 0,
            tenant_Commission: parseFloat(leaseDetails?.tenantCommission) || 0,
            landlord_Commission: parseFloat(leaseDetails?.landlordCommission) || 0,
            maintenance_Fee: parseFloat(leaseDetails?.maintenanceFee) || 0,
            negotiable: true,
            currency: salesDetails?.currency?.label || '0',
            cmA_Range1: parseFloat(salesDetails?.marketAnalysis) || 0,
            cmA_Range2: parseFloat(salesDetails?.to) || 0,
            installments: parseFloat(leaseDetails?.installment) || 0,
            rentPayableTo: leaseDetails?.rentPayable || '0',
            rentBankName: leaseDetails?.bankName?.label || '0',
            rentBankAcNo: leaseDetails?.accountNo || '0',
            secDepPayableTo: leaseDetails?.secDepositPayable || '0',
            comPayableTo: leaseDetails?.commissionPayable || '0',
            key_Status: unitDetails?.statusKey?.label || '0',
            publishStatus: Boolean(advertisement?.publishStatus),
            publishDate: advertisement?.publishStatus ? new Date() : new Date('1900-01-01'),
            serviceCharge: unitDetails?.serviceCharge || '0',
            ownerOccupied: Boolean(unitDetails?.occupied ?? true),
            leased: Boolean(unitDetails?.leased),
            leaseAmount: parseFloat(unitDetails?.rentAmount) || 0,
            leaseExpiry: unitDetails?.expiryDate,
            mandate: unitDetails?.mandate?.label || '0',
            financeCompany: unitDetails?.financeOffered || '0',
            mortgaged: Boolean(unitDetails?.mortgaged ?? true),
            mortgageCompany: unitDetails?.company || '0',
            propertyRegistered: Boolean(unitDetails?.propertyRegistered ?? true),
            portfolio: parseFloat(unitDetails?.furnitureCost) || 0,
            portfolioManager: unitDetails?.furniturePlan?.label || '0',
            propertyType: unitDetails?.status?.label || '0',
            factor: 0,
            common: 0,
            cp: 0,
            effeciency: leaseDetails?.dueDate,
            listingPriceUSD: parseFloat(salesDetails?.priceinothercontry) || 0,
            monthlyIncome: (parseFloat(leaseDetails?.fixedCharges) || 0).toFixed(3),
            annualIncome: (parseFloat(leaseDetails?.variableCharges) || 0).toFixed(3),
            exp9: unitDetails?.costAccount?.label || '0',
            exp10: unitDetails?.reservedAccCode?.label || '0',
            refered_By: unitDetails?.refferedBy?.label || '0',
            refered_On: unitDetails?.reffferedDate,
            createdBy: unitDetails?.enteredBy?.label || '0',
            createdOn: unitDetails?.enteredDate,
            modifiedBy: userName || '0',
            modifiedOn: today,
          },
          unitFeatures: unitFeatures,
          unitImages: unitImages,
          unitPayables: [
            {
              description: '0',
              value: true,
              landlord: true,
              tenant: true,
            },
          ],
          unitYearlyRents: [
            {
              year: 0,
              rentPerSqftRest: 0,
              rentPerSqftKitchen: 0,
              rentPerSqftTerrace: 0,
              totalRent: 0,
              scPerSqftRest: 0,
              scPerSqftKitchen: 0,
              scPerSqftTerrace: 0,
              totalServiceCharge: 0,
              chilledWaterPerSqftRest: 0,
              chilledWaterPerSqftKitchen: 0,
              chilledWaterPerSqftTerrace: 0,
              totalChilledWaterCharge: 0,
            },
          ],
          unitFixedCharges: [
            {
              description: '0',
              amount: 0,
            },
          ],
        },
      };
      const putRes = await apiService.put('UPDATE_UNIT_RA', body);
      if (putRes?.data?.statusCode === 200 || putRes?.data?.statusCode === 201) {
        const refNo = transectionData?.refNo || leaseData?.ref_No;
        // await handleUpload(refNo);
        toast.success(putRes?.data?.message);
        setloader(false);
        if (onClose) onClose();
      } else {
        toast.warning(`${putRes?.data?.message}`);
        setloader(false);
      }
    } catch (error) {
      // Previously silent - a failed image upload or save (network error,
      // timeout, backend error) showed nothing beyond the loader stopping,
      // so a real failure looked identical to a successful save.
      console.error('Error Save Data', error);
      toast.error(error?.response?.data?.message || error?.message || 'Failed to save unit. Please try again.');
      setloader(false);
    } finally {
      setloader(false);
    }
  };
  return (
    <div className="d-flex flex-column unit-modal-form" style={{ height: '85vh' }}>
      <div className="p-3 border-bottom d-flex align-items-center justify-content-between flex-shrink-0">
        <h5 className="mb-0">{viewOnly ? t('unitMaster.viewFormTitle') : t('unitMaster.editFormTitle')}</h5>
        <button type="button" className="btn-close" aria-label="Close" onClick={handleBackClick}></button>
      </div>
      <div className="p-3" style={{ flex: 1, overflowY: 'auto', minHeight: 0 }}>
      <div className="border-box2 my-3 p-3" style={{ borderRadius: '8px' }}>
        <div className="nav nav-pills overslid d-flex gap-4 unit-modal-tabs">
          {tabList.map((tab, index) => (
            <div
              key={tab.key}
              className={`dashitems sidebar-text center ${activeTab === index ? 'sideActive' : ''}`}
              onClick={() => handleTabClick(index)}
            >
              {tab.label}
            </div>
          ))}
        </div>
      </div>
      {tabList[activeTab]?.key === 'unitMaster' && (
        <MasterDetails
          isEdit
          statusText={recordStatus}
          tableLoading={tableLoading}
          countriesList={countriesList}
          salersList={salersList}
          setCityList={setCityList}
          setTransectionData={setTransectionData}
          propertyList={propertyList}
          cityList={cityList}
          setFeaturesList={setFeaturesList}
          transectionData={transectionData}
          landlordList={landlordList}
          communityList={communityList}
          unitTypeList={unitTypeList}
          unitViewList={unitViewList}
          floorList={floorList}
          unitCategoryList={unitCategoryList}
          setcommunityList={setcommunityList}
          setunitCategoryList={setunitCategoryList}
          bedRoomList={bedRoomList}
        />
      )}
      {tabList[activeTab]?.key === 'unitDetails' && (
        <UnitDetails
          tableLoading={tableLoading}
          manDateList={manDateList}
          reserveAccList={reserveAccList}
          agent={agent}
          setTransectionData={setUnitDetails}
          keyStatusList={keyStatusList}
          unitCostList={unitCostList}
          paymentPlan={paymentPlan}
          furnishing={furnishing}
          transectionData={unitDetails}
          projectStatus={projectStatus}
          costAccount={costAccount}
          refferedBy={refferedBy}
          enteredBy={enteredBy}
          furniturePlan={furniturePlan}
        />
      )}
      {tabList[activeTab]?.key === 'unitFeatures' && <UnitFeature tableLoading={tableLoading} setFeaturesList={setFeaturesList} featuresList={featuresList} />}
      {tabList[activeTab]?.key === 'salesDetails' && (
        <SalesDetails tableLoading={tableLoading} setTransectionData={setSalesDetails} transectionData={salesDetails} countriesList={countriesList} totalArea={transectionData?.totalArea} />
      )}
      {tabList[activeTab]?.key === 'buyerSummary' && <BuyerSummery tableLoading={tableLoading} salesDetails={salesDetails} />}
      {tabList[activeTab]?.key === 'leaseDetails' && (
        <LeaseDetails
          tableLoading={tableLoading}
          setTransectionData={setLeaseDetails}
          transectionData={leaseDetails}
          bankList={bankList}
          unitClass={transectionData?.unitClass}
        />
      )}
      {tabList[activeTab]?.key === 'payable' && <Payable tableLoading={tableLoading} />}
      {tabList[activeTab]?.key === 'advertisement' && (
        <Advertisement tableLoading={tableLoading} setTransectionData={setAdvertisement} transectionData={advertisement} />
      )}
      {tabList[activeTab]?.key === 'images' && <ImagesList attachments={attachments} setAttachments={setAttachments} createEmptyRow={createEmptyRow} setDeletedFiles={setDeletedFiles} deletedFiles={deletedFiles} readOnly={viewOnly} />}
      </div>
      <div className="p-3 border-top d-flex justify-content-start gap-3 flex-shrink-0">
        {!viewOnly && (loading === true ? (
          <div className="mainbtn flex-end gap-2">
            <ClipLoader color="#ffffff" className="mt-1" size={20} />
          </div>
        ) : (
          <div className="mainbtn flex-end gap-2" onClick={handleSave}>
            <FaSave color="#fff" className="center mt-1 mx-2" />
            <div className="center">{t('common.save')}</div>
          </div>
        ))}
        <div className="mainbtnRed flex-end gap-2" onClick={handleBackClick}>
          <FaChevronLeft color="#fff" className="center mt-1 mx-2" />
          <div className="center">{viewOnly ? t('common.close') : t('common.cancel')}</div>
        </div>
      </div>
    </div>
  );
};
export default UpdateUnitMaster;
